<template>
  <div class="item">
    <div class="item_wrap">
      <span class="name">{{ item.name }}</span>
      <span class="description" v-if="item.correspondent__type">
        {{ item.correspondent__organization_group__name }}
        {{ item.correspondent__organization__name }}
        {{ item.correspondent__external__name }}
        {{ item.correspondent__employee__name }}
        {{ item.correspondent__department__name }}
      </span>
      <span>
        {{ $t('documents.fields.tasks') }}:
        {{ item.closed_tasks_count }} /
        {{ item.done_tasks_count }} /
        {{ item.in_process_tasks_count }} /
        {{ item.new_tasks_count }}
        <b-tooltip :label="$t('docflow.planControlHelp')"
                   position="is-right"
                   type="is-light">
          <b-icon icon="help-circle-outline"
                  size="is-small"
                  class="has-text-grey-light mr-0 ml-0">
          </b-icon>
        </b-tooltip>
      </span>
    </div>
    <PlanControlItem v-for="data in item.children" :v-key="data.id" :item="data"></PlanControlItem>
  </div>
</template>

<script>
  import PlanControlItem from '@/components/PlanControlItem'

  export default {
    name: 'PlanControlItem',
    props: ['item'],
    comments: {PlanControlItem}
  }
</script>

<style lang="scss" scoped>

  .item > .item {
    padding-left: 35px;
    position: relative;
    &:before {
      display: block;
      content: '';
      width: 25px;
      height: 22px;
      background: url("../assets/planItemTree.svg");
      position: absolute;
      left: 2px;
      top: -5px;
    }
  }

  .item_wrap {
    margin-bottom: 10px;

    .name {
      font-size: 16px;
      font-weight: 500;
      display: block;
    }

    .description {
      font-size: 12px;
      color: #8a8a8a;
      display: block;
    }
  }
</style>